export default "__VITE_ASSET__c2074e2a__"